// Task M4: resolution matrix hiển thị paper trading (pure, test ma trận).
import { hasCapability } from "@vninvestcharts/engine-core";
/**
 * Thứ tự ưu tiên: toggle runtime > prop tường minh > override riêng chart
 * > master workspace > localStorage cũ > mặc định bật.
 */
export function resolvePaperEnabled(input) {
    if (input.localOverride !== undefined)
        return input.localOverride;
    if (input.defaultEnabled !== undefined)
        return input.defaultEnabled;
    if (input.chartId !== undefined && input.perChart?.[input.chartId] !== undefined) {
        return input.perChart[input.chartId];
    }
    if (input.master !== undefined)
        return input.master;
    if (input.legacyEnabled !== undefined)
        return input.legacyEnabled;
    return true;
}
/** Đọc legacy key `vnsc.paper.enabled` ("1"/"0") — single-chart + fallback. */
export function readLegacyPaperEnabled() {
    try {
        if (typeof window === "undefined" || !window.localStorage)
            return undefined;
        const raw = window.localStorage.getItem("vnsc.paper.enabled");
        if (raw === "0")
            return false;
        if (raw === "1")
            return true;
    }
    catch {
        // Storage bị chặn — coi như chưa đặt.
    }
    return undefined;
}
// ---------------------------------------------------------------------------
// W0.5: gate tier cho paper trading (audit F12 — trước đó KHÔNG gate gì cả)
// ---------------------------------------------------------------------------
/**
 * Paper trading có 2 mức (AGENTS.md Rule 15 + quy tắc phân gói):
 *  - `paper_market_limit` (Community): market + limit. **Luôn mở**, kể cả `none`.
 *  - `paper_advanced` (pro): stop, stop-limit, trailing, PLO + panel quản trị rủi ro.
 *
 * Gọi ở UI khi render, KHÔNG gọi trong `resolvePaperEnabled` (hàm đó thuần và
 * đã có test ma trận cũ — giữ nguyên hợp đồng).
 *
 * S1: `capabilityGated` là kết quả `tierGated.allows(...)` (đã tính cả tier VÀ
 * allowlist `caps` của license). `hasCapability(tier, cap)` chỉ biết tier, **không biết**
 * license caps — nên nếu gate lệnh nâng cao chỉ suy ra từ tier thì license thu hẹp gói
 * bị bỏ qua đúng ở tầng UI. Truyền `undefined` giữ hành vi cũ (chỉ theo tier).
 */
export function canUsePaperTrading(tier, advanced, capabilityGated) {
    if (capabilityGated !== undefined)
        return capabilityGated;
    return advanced ? hasCapability(tier, "paper_advanced") : hasCapability(tier, "paper_market_limit");
}
/** Lọc danh sách loại lệnh theo capability. Community chỉ thấy market/limit. */
export function filterOrderTypesByTier(types, tier, capabilityGated) {
    const advanced = new Set(["STOP", "STOP_LIMIT", "TRAILING", "PLO"]);
    return types.filter((t) => {
        const isAdvanced = advanced.has(t.type.toUpperCase());
        return canUsePaperTrading(tier, isAdvanced, capabilityGated
            ? isAdvanced
                ? capabilityGated.paperAdvanced
                : capabilityGated.paperMarketLimit
            : undefined);
    });
}
